<template>
  <g
    :transform="transform"
    class="icon"
    @click.stop="showDetail"
  >
    <use
      x="0"
      y="0"
      :width="visualizationPinSize.width"
      :height="visualizationPinSize.height"
      :fill="visualizationPinColor"
      :transform="visualizationPinTransform"
      xlink:href="#pin-person"
    />
  </g>
</template>

<script>
import map from '@/mixins/map.js';
import mixinsPin from '@/mixins/map_pin.js';

export default {
  mixins: [map, mixinsPin],
  props: {
    person: {
      type: Object,
      default() {
        return null;
      },
    },
    visualizationPinSize: {
      type: Object,
      default() {
        return {
          width: 0,
          height: 0,
        };
      },
    },
  },
  computed: {
    destinationList: ({ $store }) => $store.state.searchResult.destinations,
    currentFloorId: ({ $store }) => $store.state.current.floorId,
    personPosition: ({ person, currentFloorId }) => person.thingPositions.find((position) => position.floor.id === currentFloorId),
    isVisualizationPinSelected() {
      const { destination } = this.$store.state.searchResult;
      return destination.id === this.person.id && destination.type === this.person.type;
    },
    isVisualizationPinSearched() {
      return this.destinationList.some((result) => {
        if (result.type.indexOf('Thing') < 0 || result.user == null) return false;
        return result.id === this.person.id;
      });
    },
    // NOTE: 座標の調整
    transform() {
      let x = 0;
      let y = 0;
      if (this.personPosition) {
        x = this.personPosition.positionX;
        y = this.personPosition.positionY;
      }
      return `translate(${x}, -${y}) scale(${1 / this.$store.state.map.scale})`;
    },
    // NOTE: 選択中のスポットはサイズを大きくする
    visualizationPinScale: ({ isVisualizationPinSelected }) => ((isVisualizationPinSelected) ? 2.5 : 1),
    visualizationPinTransform() {
      // NOTE: ピンの先端を座標に合わせる
      const width = -this.visualizationPinSize.width / 2;
      const height = -this.visualizationPinSize.height;
      return `scale(${this.visualizationPinScale}) translate(${width}, ${height})`;
    },
  },
  methods: {
    showDetail() {
      // NOTE: 仲居さんとの共通メソッド
      this.$store.commit('current/switchGroupSelected', false);
      this.$store.commit('current/setDestination', this.person);
      this.$store.dispatch('searchResult/getThing', this.person.id);
      this.$store.dispatch('destinationDetail/show');

      // NOTE: 女将さん固有メソッド
      this.$store.dispatch('map/switchShiftMap', this.personPosition.positionX);
      this.$store.dispatch('appNavigator/updateNoOperationTimer', this.$store.state.appNavigator.noOperationTimer);
      this.$store.dispatch('searchResult/clearDestinations');
    },
  },
};
</script>

<style coped lang="scss">
/*
 .icon {
   transition: all 1s linear 0;
 }
 */
 </style>



// WEBPACK FOOTER //
// single.vue?02d87d3a